import { MutationTree } from "vuex";
import { INotificationState, INotificationItem } from "./interface";

export default <MutationTree<INotificationState>> {

	addToast(state, toast: INotificationItem) {
		state.toasts.push(toast);
	},

	deleteToast(state, toastId: number) {
		if (!toastId) return;

		for (let i = 0; i < state.toasts.length; i++) {
			if (state.toasts[i].id === toastId) {
				state.toasts.splice(i, 1);
				break;
			}
		}
	},

	setToasts(state, toasts: INotificationItem[]) {
		state.toasts = toasts;
	},

	clearToasts(state) {
		state.toasts = [];
	}

}